import { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { getSearchURLQueryParameters } from '@ama-selections/ui'
import { useRouter } from 'next/router'
import { BellIcon, FilterSearchBarIcon, MapPinIcon } from 'components/icons'
import Input from 'components/form/Home/Input'
import Button from 'components/home/common/Button'
import MobileDestinationsModal from 'components/modals/home/destinations/MobileDestinationsModal'
import { DashboardSearchFormFields } from 'data/types/home/search'
import ServiceCategorySearchModal from 'components/modals/home/search/services/ServiceCategorySearchModal'
import { getServiceCategoryLabel } from 'data/helpers/search'
import ServiceSpecificSearchModal from 'components/modals/home/search/services/ServiceSpecificSearchModal'

const MobileServiceSearchControls = () => {
  const { watch, control, getValues, reset } = useFormContext<DashboardSearchFormFields>()
  const router = useRouter()

  const [isDestinationOpen, setIsDestinationOpen] = useState(false)
  const [isFiltersOpen, setIsFiltersOpen] = useState(false)
  const [setSearchOpen, setIsSearchOpen] = useState(false)

  return (
    <>
      <div className="relative flex flex-col w-full gap-8 px-25">
        <Input
          variant="searchbar"
          prefix={<MapPinIcon />}
          placeholder="Find your destination"
          value={watch('destination_search')}
          readOnly
          onClick={() => setIsDestinationOpen(true)}
        />

        <Input
          variant="searchbar"
          prefix={<BellIcon />}
          placeholder="What are you looking for?"
          readOnly
          value={watch('search')}
          onClick={() => setIsSearchOpen(true)}
        />

        <Input
          variant="searchbar"
          prefix={<FilterSearchBarIcon />}
          placeholder="Filters"
          onClick={() => setIsFiltersOpen(true)}
          value={getServiceCategoryLabel(
            watch('categories'),
            watch('subCategories'),
            watch('serviceFilters'),
            {
              base: 'Filter',
              singularEnding: '',
              pluralEnding: 's',
            },
          ) ?? ''}
          readOnly
        />

        <Button
          block
          variant="primary"
          onClick={() => router.push({
            pathname: '/services/all',
            query: getSearchURLQueryParameters({
              sort: router?.query?.sort,
              search: watch('search'),
              region: watch('destination')?.region?.slug ?? watch('destination_search'),
              categories: watch('categories'),
              subcategories: watch('subCategories'),
              filters: watch('serviceFilters'),
            }),
          })}
        >
          Search
        </Button>

        <hr className="mt-50 border-grey-230 mb-25"/>
      </div>

      <ServiceCategorySearchModal
        isOpen={isFiltersOpen}
        control={control}
        onClose={() => setIsFiltersOpen(false)}
        getValues={getValues}
        reset={reset}
      />

      <MobileDestinationsModal
        isOpen={isDestinationOpen}
        onClose={() => setIsDestinationOpen(false)}
        redirect={false}
      />

      <ServiceSpecificSearchModal
        isOpen={setSearchOpen}
        onClose={() => setIsSearchOpen(false)}
        showDisclaimer={false}
      />
    </>
  )
}

export default MobileServiceSearchControls
